import React, { useState } from 'react';
import '../styles/calculator.css';
import shadowLogo from '../assets/itiniri_shadow.png';

const Calculator = () => {
  const [attendees, setAttendees] = useState(50);

  // Helper function to format numbers with commas
  const formatNumberWithCommas = (number) => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

// Pricing Logic
let yourPricing;
if (attendees <= 2999) {
  yourPricing = 100;
} else if (attendees <= 4999) {
  yourPricing = 300;
} else if (attendees <= 10000) {
  yourPricing = 500;
} else {
  yourPricing = 'CONTACT_US';
}

  const brushfirePricing = attendees * 1; // $1 per attendee
  const regFoxPricing = attendees * 0.99;
  const paperProgramPricing = attendees * 0.6;

  // Helper Function to Format Costs
  const formatCost = (cost, addPlus = false) => {
    if (cost === 'CONTACT_US') return 'Contact Us';
    return `$${formatNumberWithCommas(Math.round(cost))}${addPlus ? '+' : ''}`;
  };

  const handleSliderChange = (value) => {
    setAttendees(value);

    const sliderElement = document.getElementById('attendees-range');
    const percentage = ((value - 50) / (20000 - 50)) * 100;

    sliderElement.style.background = `linear-gradient(to right, #8ec7db ${percentage}%, #d3d3d3 ${percentage}%)`;
  };

  return (
    <div className="calculator-container">
      <h2>Event Cost Savings Calculator</h2>
      <p>Use the slider to select the number of attendees:</p>

      <div className="input-section">
        <label htmlFor="attendees">
          Attendees: {formatNumberWithCommas(attendees)}
        </label>
        <input
          type="range"
          id="attendees-range"
          min="50"
          max="20000"
          step="50"
          value={attendees}
          onChange={(e) => handleSliderChange(Number(e.target.value))}
          className="slider"
        />
      </div>

      <div className="your-pricing">
        <img src={shadowLogo} alt="Itiniri Shadow Logo" className="shadow-logo" />
        <p>{formatCost(yourPricing)}</p>
      </div>

      <div className="results-row">
        <div className="result">
          <h3>Paper Programs</h3>
          <p>{formatCost(paperProgramPricing, true)}</p>
        </div>
        <div className="result">
          <h3>RegFox</h3>
          <p>{formatCost(regFoxPricing, true)}</p>
        </div>
        <div className="result">
          <h3>Brushfire</h3>
          <p>{formatCost(brushfirePricing, true)}</p>
        </div>
      </div>

      <p className="disclaimer">
        Based off of pricing from competitor websites.
      </p>
    </div>
  );
};

export default Calculator;